import { RootState } from '../index'
import { useSelector } from 'react-redux'
import { BrokerInfo } from './reducer'

export function useBrokerInfo(): BrokerInfo | undefined {
  return useSelector((state: RootState) => state.broker.brokerInfo)
}
